import { HttpParams, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ErrorOr } from '../../../results/error-or/error-or';
import { Result } from '../../../results/error-or/enums/result.enum';
import { ApiProblemDetails } from '../../../results/error-or/interfaces/problem-details.interface';
import { ErrorOrHttpExtensions } from '../../../results/error-or/Extensions/error-or.extensions';
import { IRequestOptions } from '../models/request-options.model';
import { URLS } from '../../../../../trash/shared/constants/URLS';

function mapByStatusCode(event: HttpResponse<any>, router: Router): HttpResponse<any> {
    const response = event.body; // The response body
    const statusCode = event.status; // Get the HTTP status code from the response

    if (statusCode >= 200 && statusCode < 300) {
        // Success status codes
        if (response && Object.keys(response).length > 0) {
            return event.clone({ body: ErrorOr.fromValue(response) }); // Return content wrapped in ErrorOr<TResponse>
        } else {
            return event.clone({ body: ErrorOr.fromValue(Result.SUCCESS) }); // No content, return ErrorOr<Success>
        }
    } else if (statusCode === 401) {
        router.navigateByUrl(URLS.LOGIN);
    } else if (statusCode === 403) {
        router.navigateByUrl(URLS.FORBIDDEN);
    } else if (statusCode > 500) {
        router.navigateByUrl(URLS.FAILURE);
    } else {
        const problemDetails: ApiProblemDetails = response;
        const errors = ErrorOrHttpExtensions.toErrorOrErrors(problemDetails);
        return event.clone({ body: ErrorOr.fromErrors(errors) }); // Wrap errors in ErrorOr
    }

    return event; // Pass through non-HttpResponse events
}

function createRequestOptionsWithParams(params: Record<string, any> | undefined): IRequestOptions | undefined {
    return params
        ? {
              params: createHttpParams(params)
          }
        : undefined;
}

function createHttpParams(params: Record<string, any>): HttpParams {
    let httpParams = new HttpParams();
    if (params) {
        Object.keys(params).forEach(key => {
            const value = params[key];
            if (value !== undefined && value !== null) {
                if (Array.isArray(value)) {
                    // Append each value in the array
                    value.forEach(arrayItem => {
                        httpParams = httpParams.append(key, String(arrayItem));
                    });
                } else {
                    httpParams = httpParams.set(key, String(value));
                }
            }
        });
    }
    return httpParams;
}

export const httpUtils = {
    mapByStatusCode,
    createRequestOptionsWithParams,
    createHttpParams
};
